import Pills from "@/components/Pills";
import { SWW } from "@/config/toast";
import { submitVideoFeedback } from "@/helpers/api/service/Video";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { resetOffCanvasView, updateOffCanvasView } from "@/store/slices/offCanvas";

const FeedbackContent = (props: { questionId: string }) => {
  const [showForm, setShowForm] = useState<boolean>(false);
  const [feedbackText, setFeedbackText] = useState<string>("");
  const [selectedPills, setSelectedPills] = useState<any>({});
  const dispatch = useDispatch();

  const tags = ["Question not correct", "Wrong answer/solution", "Explanation is not clear", "Solution needed in other language", "Others"];

  const handleTagClick = (tag: string) => {
    if (tag === "Others") {
      setShowForm(!showForm);
    }

    setSelectedPills((prevSelectedPills: any) => {
      if (!prevSelectedPills[tag]) {
        return { ...prevSelectedPills, [tag]: tag };
      }
      // If the tag is already selected, remove it
      const { [tag]: _, ...updatedPills } = prevSelectedPills;
      return updatedPills;
    });
  };

  const handleFeedbackSubmit = () => {
    // If "Others" tag is selected and feedbackText has a value, include it
    if (Object.keys(selectedPills).includes("Others") && feedbackText.trim() !== "") {
      selectedPills["Others"] = feedbackText.trim().slice(0, 30);
    }else if (Object.keys(selectedPills).includes("Others") && feedbackText.trim() === "") {
      delete selectedPills["Others"];
    }

    submitVideoFeedback(props.questionId, Object.values(selectedPills)).then((res: any) => {
      dispatch(resetOffCanvasView());
    });
  };

  return (
    <div className="min-w-96 max-w-screen-sm flex flex-col gap-2 mt-10 mb-5 px-10">
      <span className="flex justify-center text-xl text-accent font-semibold">Thanks for your feedback!</span>
      <Pills items={tags.map((item: string) => ({ text: item, onClick: () => handleTagClick(item), type: "pillShadow", selected: Object.keys(selectedPills).includes(item), className: "clickable text-body" }))} className="!my-2" />
      {showForm && (
        <>
          <textarea
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            placeholder="Tell us about your experience..."
            className="input h-16 sm:h-32"
          />
        </>
      )}
      <div className="w-full sm:w-max sm:gap-5 mx-auto">
        <button type="button" className="btn btn-primary" onClick={() => handleFeedbackSubmit()}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default FeedbackContent;
